import {getApp, initializeApp} from 'firebase/app';
import {
  getFirestore,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  connectFirestoreEmulator
} from 'firebase/firestore';
import {
  getDatabase,
  ref,
  update,
  onDisconnect,
  serverTimestamp,
  connectDatabaseEmulator
} from 'firebase/database';
import {getAuth} from 'firebase/auth';

const app = (() => {
  try {
    return initializeApp({
      apiKey: process.env.FIREBASE_API_KEY,
      authDomain: process.env.FIREBASE_AUTH_DOMAIN,
      projectId: process.env.FIREBASE_PROJECT_ID,
      storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
      appId: process.env.FIREBASE_APP_ID,
      measurementId: process.env.FIREBASE_MEASUREMENT_ID
    });
  } catch (e) {
    if (e.code === 'app/duplicate-app') return getApp('[DEFAULT]');
    console.error(e);
    throw new Error(e);
  }
})();

try {
  initializeFirestore(app, {
    /** @link https://github.com/firebase/firebase-js-sdk/issues/7860 */
    useFetchStreams: false,
    // experimentalForceLongPolling: true,
    // experimentalAutoDetectLongPolling: true,
    localCache: persistentLocalCache({
      // cacheSizeBytes: CACHE_SIZE_UNLIMITED,
      tabManager: persistentMultipleTabManager()
    })
  });
} catch (e) {
  if (e.code !== 'failed-precondition') console.error(e.code, '==', e);
}

export const db = getFirestore(app);

const database = getDatabase(app);

if (!db._settingsFrozen && process.env.LOCAL_FIRESTORE) {
  connectFirestoreEmulator(db, '127.0.0.1', 8131); // test firestore event on local
  connectDatabaseEmulator(database, '127.0.0.1', 9050); // Use the Realtime Database emulator
}
// disableNetwork(db).then(); // test offline mode for firestore

export const auth = getAuth(app);

export const updateStatusUser = async convoId => {
  const userStatusRef = ref(database, 'users/' + convoId);
  const disconnectRef = onDisconnect(userStatusRef);

  await Promise.all([
    update(userStatusRef, {
      isOnline: true,
      startActive: serverTimestamp(),
      lastActive: serverTimestamp()
    }),
    disconnectRef.update({isOnline: false, lastActive: serverTimestamp()})
  ]);
};
